module.exports = __webpack_public_path__ + "static/aws_practitioner-d039122b921754e8fd452d44bb0b9ef8.png";